import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { AccessibilityToolbar } from './components/AccessibilityToolbar';
import { SuperAdminDashboard } from './components/SuperAdminDashboard';
import { AACBoard } from './components/AACBoard';
import { ExecutiveDashboard } from './components/ExecutiveDashboard';
import { LayoutDashboard, Shield, Volume2, TrendingUp } from 'lucide-react';

export const AppShell: React.FC = () => {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState<'admin' | 'aac' | 'analytics'>('admin');

  return (
    <div className="min-h-screen bg-slate-50 flex flex-col">
      {/* Top Application Header */}
      <header className="bg-blue-700 text-white shadow-md px-6 py-4 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 bg-white text-blue-700 rounded-lg flex items-center justify-center font-black text-xl">
            A
          </div>
          <div>
            <h1 className="text-xl font-extrabold leading-none">{t('app_name')}</h1>
            <p className="text-xs text-blue-200 mt-1">{t('tagline')}</p>
          </div>
        </div>

        {/* Global Tab Switcher */}
        <nav className="flex gap-2">
          <button
            onClick={() => setActiveTab('admin')}
            className={`px-4 py-2 rounded-lg font-bold text-sm flex items-center gap-2 transition-all ${
              activeTab === 'admin' ? 'bg-white text-blue-700 shadow' : 'bg-blue-600 text-white hover:bg-blue-500'
            }`}
          >
            <Shield className="w-4 h-4" />
            {t('super_admin')}
          </button>
          <button
            onClick={() => setActiveTab('aac')}
            className={`px-4 py-2 rounded-lg font-bold text-sm flex items-center gap-2 transition-all ${
              activeTab === 'aac' ? 'bg-white text-blue-700 shadow' : 'bg-blue-600 text-white hover:bg-blue-500'
            }`}
          >
            <Volume2 className="w-4 h-4" />
            {t('aac_board')}
          </button>
          <button
            onClick={() => setActiveTab('analytics')}
            className={`px-4 py-2 rounded-lg font-bold text-sm flex items-center gap-2 transition-all ${
              activeTab === 'analytics' ? 'bg-white text-blue-700 shadow' : 'bg-blue-600 text-white hover:bg-blue-500'
            }`}
          >
            <TrendingUp className="w-4 h-4" />
            Executive Analytics
          </button>
        </nav>
      </header>

      {/* Main Content Workspace */}
      <main id="main-content" className="flex-1 p-6 max-w-7xl w-full mx-auto">
        {activeTab === 'admin' && <SuperAdminDashboard />}
        {activeTab === 'aac' && <AACBoard />}
        {activeTab === 'analytics' && <ExecutiveDashboard />}
      </main>

      {/* Floating Accessibility Control Toolbar */}
      <AccessibilityToolbar />
    </div>
  );
};
